/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_UseInputs */

const cs_templates_use = /** @type {(inputs: Templates_UseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Použít`)
};

const en_templates_use = /** @type {(inputs: Templates_UseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use`)
};

/**
* | output |
* | --- |
* | "Use" |
*
* @param {Templates_UseInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_use = /** @type {((inputs?: Templates_UseInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_UseInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_use(inputs)
	return cs_templates_use(inputs)
});